import { memo, useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";

type Props = {
	hotelID: string;
	reservationID: string;
};

export const TransitionEditReservationButtonOfOperationForReservation = memo(({ hotelID, reservationID }: Props) => {
	const navigate = useNavigate();
	/**
	 * 予約編集画面への遷移
	 */
	const handleClickTransitionToEditReservation = useCallback(() => {
		const path = generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.EDIT, { hotelID, reservationID });

		navigate(generatePath(path, { hotelID, reservationID }));
	}, [hotelID, navigate, reservationID]);

	return (
		<Button variant="outline" type="button" size="sm" onClick={handleClickTransitionToEditReservation}>
			予約内容の変更
		</Button>
	);
});
